import { PdfData } from "@/models/pdfData";
import { IconButton, Tooltip } from "@mui/material";
import { Sports } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import React from "react";

const OpenTabletViewButton: React.FC<{ storedGame: PdfData }> = ({
  storedGame,
}) => {
  return (
    <Tooltip title={"Referee Ansicht öffnen"}>
      <NavLink
        to={`game/${storedGame.scope}/${storedGame.samsId}/referee-tablet`}
      >
        <IconButton>
          <Sports />
        </IconButton>
      </NavLink>
    </Tooltip>
  );
};

export default OpenTabletViewButton;
